module.exports = __webpack_public_path__ + "static/img/4445_phase_function_Paper_Points.131615b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4445_phase_function_Paper_Points.png
// module id = TD8T
// module chunks = 0